function renderScrollTriggerFadeSlide(customSelector) {

	let selector = customSelector || '.gsap--caramella';
	let defaultanim = {autoAlpha: 0, y: 50};
	let defaultduration = {duration: 1, autoAlpha: 1, y: 0};

	if (typeof ScrollTrigger !== 'undefined') {
		jQuery(selector).each(function (i, box) {
			let $this = jQuery(this);

			if ($this.data('gsap-initialized')) return;
			let customanim = $this.data('anim');
			let customduration = $this.data('duration');
			let mergedanim = Object.assign({}, defaultanim, customanim);
			let mergedduration = Object.assign({}, defaultduration, customduration);
			let anim = gsap.fromTo(box, mergedanim, mergedduration);
			ScrollTrigger.create({
				trigger: box,
				animation: anim,
				toggleActions: 'play none none none',
				once: true
			});
			$this.data('gsap-initialized', true);
		});
	} else {
		console.warn("ScrollTrigger is not loaded so we are skipping it.");
	}

}

window.caramellaSafeExecute(renderScrollTriggerFadeSlide);
